/* eslint-disable react/display-name */

import cc from "classcat"
import { ReactNode, useEffect } from "react"
import { MDXProvider, MDXProviderComponentsProp } from "@mdx-js/react"
import { useLocation } from "react-router-dom"

interface Props {
  children: ReactNode
  id?: string
  className?: string
}

const components: MDXProviderComponentsProp = {
  wrapper: (props) => <article>{props.children}</article>,
  blockquote: (props) => <div className="message my-6">{props.children}</div>,
  ul: (props) => {
    console.log("List props", props)
    if (props.className?.includes("block-list")) {
      return <ul className={props.className}>{props.children}</ul>
    } else {
      return (
        <ul className={cc(["bullet-list", props.className])}>
          {props.children}
        </ul>
      )
    }
  },
  ol: (props) => (
    <ol className={cc(["num-list", props.className])}>{props.children}</ol>
  ),
}

export const Main = ({ id, className, children }: Props) => {
  const location = useLocation()

  useEffect(() => {
    if (location.hash !== "") {
      const el = document.getElementById(location.hash.replace(/^#/, ""))
      if (el) {
        el.scrollIntoView()
      } else {
        window.scrollTo(0, 0)
      }
    } else {
      window.scrollTo(0, 0)
    }
  }, [location])

  return (
    <MDXProvider components={components}>
      <main role="main" className={cc(["p-10", className])} id={id}>
        {children}
      </main>
    </MDXProvider>
  )
}
